import { ValidationErrorMessage } from './constants/validation-error.message';
import { TValidatorResponse } from './types/validator-response.types';

const EMAIL_REGEX =
  /^(?!.*\.\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;

export const isValidEmail = (value: string): TValidatorResponse =>
  EMAIL_REGEX.test(value) ? undefined : ValidationErrorMessage.IncorrectEmail();
